sn-how-it-works-type-2 {
  display: block;

  .sn-how-it-works-type-2__container {
    // Match the signnow me-container width so this lines up with the
    // me-container-based blocks on the page ($media-desktop (1440) was too wide).
    max-width: $sn-container-max-width;
    margin: 0 auto;
    padding: 0 $spacing-xl $spacing-3xl;

    @include desktop-lg {
      padding-top: 0;
      padding-bottom: $spacing-6xl + $spacing-3xl;
    }
  }

  .sn-how-it-works-type-2__list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: $spacing-3xl;

    @include desktop {
      flex-direction: row;
      align-items: flex-start;
      gap: $spacing-4xl;
    }
  }

  .sn-how-it-works-type-2__item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: $spacing-xl;

    @include desktop {
      flex-direction: row;
      align-items: flex-start;
      flex: 1;
      gap: $spacing-xl;
    }
  }

  .sn-how-it-works-type-2__image-wrapper {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .sn-how-it-works-type-2__image {
    width: 70px;
    height: 70px;
    object-fit: contain;
  }

  .sn-how-it-works-type-2__content {
    font-size: map-get($map: $font-sizes, $key: xl);
    line-height: 1.5;
    margin: 0;
    text-align: center;
    color: $text-color-primary;

    @include desktop {
      text-align: left;
    }
  }

  .sn-how-it-works-type-2__title {
    font-weight: 700;
  }

  me-heading {
    display: block;
    margin-bottom: $spacing-3xl;
    text-align: center;

    @include desktop {
      text-align: left;
    }
  }
}
